import { useState, useEffect } from 'react';
import { useTheme } from '../../../context/theme';
import { api } from '../../../utils/api';
import { Card, EmptyState } from '../../../components/ui';
import { SkeletonList } from '../../../components/ui/Skeletons';

export default function SiteActivityFeed({ siteId }) {
  const { theme, isDark } = useTheme();
  const [activity, sA] = useState([]);
  const [loading, sL] = useState(true);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    api.get('/api/activity?site_id=' + siteId + '&limit=30')
      .then(d => { sA(d.activity || []); sL(false); })
      .catch(() => sL(false));
  }, [siteId]);

  if (loading) {
    return (
      <Card>
        <h3 style={{ fontSize: 14, fontWeight: 400, fontFamily: "'DM Sans', sans-serif", color: theme.text, margin: '0 0 12px' }}>Recent Activity</h3>
        <SkeletonList count={3} />
      </Card>
    );
  }

  const shown = expanded ? activity : activity.slice(0, 3);

  return (
    <Card>
      <h3 style={{ fontSize: 14, fontWeight: 400, fontFamily: "'DM Sans', sans-serif", color: theme.text, margin: '0 0 12px' }}>Recent Activity</h3>
      {activity.length === 0 && <EmptyState icon="clipboard-list" title="No activity recorded" description="Activity will appear here as your team works" />}
      {shown.map((a, i) => (
        <div key={i} className="activity-item hover-row" style={{ padding: '8px 0', borderBottom: i < shown.length - 1 ? `1px solid ${theme.border}` : 'none', fontSize: 13, cursor: 'default' }}>
          <span className="act-user" style={{ color: theme.text, fontWeight: 600 }}>{a.user_name}</span>
          <span className="act-verb" style={{ color: theme.textSecondary }}> {({ status_change: 'changed', assignment: 'assigned', upload: 'uploaded' }[a.action] || a.action)} </span>
          <span className="act-item" style={{ color: '#4ADE80', fontWeight: 500 }}>{a.item_doc}</span>
          {a.old_value && (
            <span>
              <span className="act-verb" style={{ color: 'rgba(255,255,255,0.58)' }}> from </span>
              <span className="act-old" style={{ color: '#EF4444' }}>{a.old_value}</span>
              <span className="act-verb" style={{ color: 'rgba(255,255,255,0.58)' }}> → </span>
              <span className="act-new" style={{ color: '#4ADE80' }}>{a.new_value}</span>
            </span>
          )}
          <div className="act-time" style={{ fontSize: 12, color: 'rgba(255,255,255,0.58)', marginTop: 2 }}>{new Date(a.created_at).toLocaleString()}</div>
        </div>
      ))}
      {activity.length > 3 && (
        <button
          onClick={() => setExpanded(!expanded)}
          style={{
            display: 'block', width: '100%', padding: '10px 0', marginTop: 12,
            background: isDark ? 'rgba(59,130,246,0.1)' : 'rgba(59,130,246,0.06)',
            border: '1px solid ' + (isDark ? 'rgba(59,130,246,0.3)' : 'rgba(59,130,246,0.2)'),
            borderRadius: 8, color: '#4ADE80', cursor: 'pointer', fontSize: 13, fontWeight: 600, textAlign: 'center'
          }}
        >
          {expanded ? 'Show Less ▴' : 'Show All Activity (' + activity.length + ') ▾'}
        </button>
      )}
    </Card>
  );
}
